import React from 'react';
import MuiTypography from '@mui/material/Typography';

function Typography({ children, ...restProps }) {
  return <MuiTypography {...restProps}>{children}</MuiTypography>;
}

export default Typography;
